import { Reveal, Eyebrow } from "./Reveal";
import { IMG } from "../data/content";

const NEARBY = [
    "Little India",
    "Kapitan Keling Mosque",
    "Goddess of Mercy Temple",
    "Clan Jetties",
    "Pinang Peranakan Mansion",
    "George Town Street Art",
];

const GeorgeTown = () => (
    <section
        id="george-town"
        data-testid="george-town-heritage-section"
        className="ihcc-grain relative overflow-hidden bg-heritage-ink py-24 md:py-36"
    >
        <div className="relative z-10 mx-auto grid max-w-7xl gap-16 px-5 md:grid-cols-2 md:items-center md:px-10 lg:gap-24">
            <Reveal className="order-2 md:order-1">
                <div className="group relative overflow-hidden rounded-2xl">
                    <img
                        src={IMG.facadeAngle}
                        alt="The IHCC heritage shophouse on Lebuh Pantai, George Town — a cultural attraction in Penang's UNESCO heritage zone"
                        className="h-[380px] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05] md:h-[520px]"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-heritage-ink/55 via-transparent to-transparent" />
                    <p className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-parchment/90">
                        57 Lebuh Pantai · The Heritage Shophouse
                    </p>
                </div>
            </Reveal>

            <div className="order-1 md:order-2">
                <Reveal>
                    <Eyebrow dark>George Town · Penang</Eyebrow>
                    <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-heritage-parchment sm:text-4xl lg:text-5xl">
                        One of George Town's Essential{" "}
                        <em className="text-heritage-gold">Heritage Attractions</em>
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mt-8 text-base leading-relaxed text-heritage-parchment/75">
                        George Town has always been a meeting of cultures — a port city where
                        India, China, the Malay world and Europe traded, built and flourished side
                        by side. IHCC belongs to this city: a cultural centre in Penang where the
                        Indian chapter of that story is preserved inside a heritage shophouse on
                        Lebuh Pantai, once the city's great mercantile street.
                    </p>
                    <p className="mt-5 text-base leading-relaxed text-heritage-parchment/75">
                        Planning things to do in George Town? Pair your visit to IHCC with the
                        heritage attractions surrounding it — all within walking distance in the
                        UNESCO zone.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <ul className="mt-9 flex flex-wrap gap-3">
                        {NEARBY.map((n) => (
                            <li
                                key={n}
                                className="rounded-full border border-heritage-gold/30 px-5 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-heritage-gold/90 transition-colors duration-300 hover:border-heritage-gold hover:text-heritage-gold"
                            >
                                {n}
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </div>
    </section>
);

export default GeorgeTown;
